import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterPipe } from './filter.pipe';
import { MinuteSecondsPipe } from './minuteSeconds.pipe';
import { TruncateStringPipe } from './truncate-string.pipe';
import { TimeAgoPipe } from './time-ago.pipe';
import { HighlightPipe } from './highlight.pipe';
import { CompareTextPipe } from './compareText.pipe';
import { MarkdownPipe } from './markdown.pipe';

@NgModule({
   imports: [
      CommonModule
   ],
   declarations: [
      FilterPipe,
      MinuteSecondsPipe,
      TruncateStringPipe,
      TimeAgoPipe,
      HighlightPipe,
      CompareTextPipe,
      MarkdownPipe
   ],
   exports: [
      FilterPipe,
      MinuteSecondsPipe,
      TruncateStringPipe,
      TimeAgoPipe,
      HighlightPipe,
      CompareTextPipe,
      MarkdownPipe
   ]
})
export class HelpersModule { }
